import { render } from "./WizardShell.vue?vue&type=template&id=9349009a"
import script from "./WizardShell.vue?vue&type=script&lang=js"
export * from "./WizardShell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__